import { render } from "./CampaignCategoryManageCreatePage.vue?vue&type=template&id=72297394&lang=true"
import script from "./CampaignCategoryManageCreatePage.vue?vue&type=script&lang=js"
export * from "./CampaignCategoryManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__